interface ButtonProps {
  txt: string;
  action: () => void;
  isFullColor: boolean;
}

export const LoginButton: React.FC<ButtonProps> = ({
  txt,
  action,
  isFullColor,
}) => {
  return <button
      className={`login-btn ${isFullColor? "full-clr": ""}`}
      onClick={action}
    >
      {txt}
    </button>
}
